import { ALLOWED_ATTACHMENT_SOURCE_TYPE } from '@OpsQuality/constants'

import { AttachmentsType } from '../types'

import attachmentStyles from './styles.css'
import { ExtraPropsType } from './types'

export const PLACEMENT = 'file-list-modal'
export const ZOOM_SCALE = 0.5

export const MODULE_TYPES = {
    WO_EXCPETION_LIST: 'woExceptionList',
    INVENTORY_QC: 'inventoryQc',
    CAR_DETAILS: 'carDetails',
}

export const getExtraProps = (): ExtraPropsType => {
    return {
        functionalProp: (file: AttachmentsType) => {
            if (file.source === ALLOWED_ATTACHMENT_SOURCE_TYPE.QC) {
                return {
                    icon: 'QC',
                    style: attachmentStyles.qc,
                    canBeDeletedProp: true,
                }
            }
            if (file.source === ALLOWED_ATTACHMENT_SOURCE_TYPE.FICTIV) {
                return {
                    icon: 'FICTIV',
                    style: attachmentStyles.fictiv,
                    canBeDeletedProp: true,
                }
            }

            return {
                icon: 'MP',
                style: attachmentStyles.mp,
                canBeDeletedProp: true,
            }
        },
    }
}

export const isVisibleToCustomer = (visibleToCustomer: boolean | null) =>
    !(visibleToCustomer === false)
